import { render, staticRenderFns } from "./KycTitle.vue?vue&type=template&id=b4d7c39c"
import script from "./KycTitle.vue?vue&type=script&lang=js"
export * from "./KycTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports